import { Component, Input } from '@angular/core';
import { TagItemDto } from '@artemis-software/wr-api';

@Component({
  standalone: false,
  selector: 'wr-short-tag-list',
  templateUrl: './short-tag-list.component.html',
  styleUrls: ['./short-tag-list.component.scss'],
})
export class ShortTagListComponent {
  @Input() tags: TagItemDto[] = [];
}
